import type {
  ExportItemStatusReportRequest,
  FileResponse,
  GetItemDefinitionListRequest,
  GetItemDefinitionListRequestV2,
  GetListResponseOfItemDefinitionSimpleResponse,
  GetListResponseOfSelectOption,
  ItemDefinitionRequest,
  ItemDefinitionResponse,
} from 'src/api/ProactApiClient';
import {itemDefinitionApiClient} from 'src/api/ProactApiClientInstances';
import {emptySplitApi} from '../api';
import {clientQuery, voidClientQuery} from '../clientQuery';

export const itemDefinitionApi = emptySplitApi.injectEndpoints({
  endpoints: builder => ({
    getItemDefinitionList: builder.query<
      GetListResponseOfItemDefinitionSimpleResponse,
      GetItemDefinitionListRequest
    >({
      queryFn: clientQuery(params => itemDefinitionApiClient.list(params)),
      providesTags: ['ItemDefinitions'],
    }),
    getItemDefinitionListV2: builder.query<
      GetListResponseOfItemDefinitionSimpleResponse,
      GetItemDefinitionListRequestV2
    >({
      queryFn: clientQuery(params => itemDefinitionApiClient.listV2(params)),
      providesTags: ['ItemDefinitions'],
    }),
    getItemDefinitionSelectOptions: builder.query<
      GetListResponseOfSelectOption,
      GetItemDefinitionListRequest
    >({
      queryFn: clientQuery(params =>
        itemDefinitionApiClient.listSelectOptions(params)
      ),
      providesTags: ['ItemDefinitions'],
    }),
    getItemDefinition: builder.query<ItemDefinitionResponse, number>({
      queryFn: clientQuery(id => itemDefinitionApiClient.details(id)),
      providesTags: ['ItemDefinitions'],
    }),
    createItemDefinition: builder.mutation<
      ItemDefinitionResponse,
      ItemDefinitionRequest
    >({
      queryFn: clientQuery(request => itemDefinitionApiClient.create(request)),
      invalidatesTags: ['ItemDefinitions'],
    }),
    updateItemDefinition: builder.mutation<
      ItemDefinitionResponse,
      ItemDefinitionRequest
    >({
      queryFn: clientQuery(request => itemDefinitionApiClient.update(request)),
      invalidatesTags: ['ItemDefinitions'],
    }),
    deleteItemDefinition: builder.mutation<void, number>({
      queryFn: voidClientQuery(id => itemDefinitionApiClient.delete(id)),
      invalidatesTags: ['ItemDefinitions'],
    }),
    exportItemStatusReport: builder.mutation<
      FileResponse | null,
      ExportItemStatusReportRequest
    >({
      queryFn: clientQuery(request =>
        itemDefinitionApiClient.exportItemStatusReport(request)
      ),
    }),
  }),
});

export const {
  useGetItemDefinitionListQuery,
  useGetItemDefinitionListV2Query,
  useGetItemDefinitionQuery,
  useGetItemDefinitionSelectOptionsQuery,
  useCreateItemDefinitionMutation,
  useUpdateItemDefinitionMutation,
  useDeleteItemDefinitionMutation,
  useExportItemStatusReportMutation,
} = itemDefinitionApi;
